import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../../common/SafeIcon';

const { FiAlertTriangle, FiPackage, FiEdit2 } = FiIcons;

const MerchantStockAlerts = ({ products, onReview }) => {
  const alerts = (products ?? []).filter(product => {
    if (!product?.track_inventory) return false;
    const stock = Number(product?.stock_count ?? 0);
    const threshold = Number(product?.low_stock_threshold ?? 5);
    return stock <= threshold;
  });

  const outOfStock = alerts.filter(product => Number(product?.stock_count ?? 0) <= 0).length;

  if (alerts.length === 0) {
    return (
      <div className="flex items-center gap-3 rounded-2xl border border-green-200 bg-green-50 px-5 py-4">
        <SafeIcon icon={FiPackage} className="h-5 w-5 shrink-0 text-green-600" />
        <div>
          <p className="text-sm font-bold text-green-800">Stock levels look good</p>
          <p className="text-xs text-green-700">No tracked products are below their low-stock threshold.</p>
        </div>
      </div>
    );
  }

  return (
    <section aria-labelledby="merchant-stock-alerts-title" className="overflow-hidden rounded-[28px] border border-amber-200 bg-white shadow-sm">
      <div className="flex flex-col gap-3 border-b border-amber-100 bg-amber-50 px-5 py-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-white text-amber-600">
            <SafeIcon icon={FiAlertTriangle} className="h-5 w-5" />
          </div>
          <div>
            <h3 id="merchant-stock-alerts-title" className="font-serif text-accent-navy">Inventory Alerts</h3>
            <p className="text-xs text-text-muted">
              {alerts.length} {alerts.length === 1 ? 'product needs' : 'products need'} attention
              {outOfStock > 0 ? ` · ${outOfStock} out of stock` : ''}
            </p>
          </div>
        </div>
        <span className="w-fit rounded-full border border-amber-200 bg-white px-3 py-1 text-[9px] font-black uppercase tracking-widest text-amber-700">
          Restock recommended
        </span>
      </div>

      <div className="divide-y divide-brand-light">
        {alerts.map(product => {
          const stock = Number(product?.stock_count ?? 0);
          const isOut = stock <= 0;

          return (
            <div key={product.id} className="flex items-center justify-between gap-4 px-5 py-4">
              <div className="min-w-0">
                <p className="truncate text-sm font-bold text-accent-navy">{product?.name ?? 'Unnamed product'}</p>
                <p className={`mt-1 text-xs ${isOut ? 'font-semibold text-red-600' : 'text-amber-700'}`}>
                  {isOut ? 'Out of stock' : `${stock} left`}
                  <span className="text-text-muted"> · Alert at {Number(product?.low_stock_threshold ?? 5)}</span>
                </p>
              </div>
              <button
                type="button"
                onClick={() => onReview?.(product)}
                className="flex shrink-0 items-center gap-2 rounded-xl border border-brand-dark bg-white px-3 py-2 text-[9px] font-black uppercase tracking-widest text-accent-navy transition-colors hover:border-accent-gold hover:bg-brand-light"
                aria-label={`Update stock for ${product?.name ?? 'product'}`}
              >
                <SafeIcon icon={FiEdit2} className="h-3.5 w-3.5" />
                Update
              </button>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default MerchantStockAlerts;